import { useEntityAPI } from '../../../redux/entity-api.hook';
import { projectVariationAPI } from '../redux/project-variations.slice';

export function useProjectVariations() {
  return useEntityAPI(projectVariationAPI);
}
